import script from "./noteList.vue?vue&type=script&setup=true&lang=js"
export * from "./noteList.vue?vue&type=script&setup=true&lang=js"

import "./noteList.vue?vue&type=style&index=0&id=561857ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-561857ae"]])

export default __exports__